import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
    standalone: true,
    selector: 'sh-logo-link',
    templateUrl: './logo-link.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterModule, CommonModule]
})
export class ShLogoLinkComponent {
    @Input() src!: string;
    @Input() alt!: string;
    @Input() compact = false;
    @Input() dark = false;
}
